import { format, isValid, formatDistanceToNow, startOfMonth } from 'date-fns';

export const formatDate = (date: Date | null | undefined): string => {
    if (!date || !isValid(date)) return '';
    return format(date, 'dd.MM.yyyy');
};

export const formatDateAPI = (date: Date | undefined): string | undefined => {
    if (!date) return undefined;
    return date.toISOString().split('T')[0];
};

export const parseSafeDate = (
    dateStr: string | null | undefined,
): Date | null => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return isValid(date) ? date : null;
};

export const formatDateWithTime = (
    date: Date | null,
    formatStr: string = 'dd.MM.yyyy, HH:mm',
): string => {
    return date ? format(date, formatStr) : '';
};

export const formatRelative = (date: Date | null): string => {
    return date ? formatDistanceToNow(date, { addSuffix: true }) : '';
};

export const getFirstDayOfMonth = (): Date => {
    return startOfMonth(new Date());
};

export const formatUTCDate = (
    date: Date,
    formatStr: string = 'yyyy-MM-dd',
): string => {
    return format(date, formatStr);
};

export const formatUTCDateTime = (
    date: Date,
    time: 'start' | 'end' = 'start',
): string => {
    const timeStr = time === 'start' ? '00:00:00' : '23:59:59';
    return `${format(date, 'yyyy-MM-dd')} ${timeStr}`;
};

export const getFirstDateOfCurrentQuarter = (today: Date): Date => {
    const year = today.getFullYear();
    const currentMonth = today.getMonth();
    const quarterStartMonth = Math.floor(currentMonth / 3) * 3;
    return new Date(year, quarterStartMonth, 1, today.getHours());
};
